import App from './App'

export default App
// eslint-disable-next-line import/export
export * from './App'
